import { request } from "../fetch";

class TabelaProcedimentoService {
  static async listarTabelas(clinicaId, tipo) {
    const qs = new URLSearchParams({ clinicaId });
    if (tipo) qs.set("tipo", tipo);
    return request(`api/adm/tabelaprocedimentos?${qs.toString()}`);
  }

  static async buscarTabelaPorId(id) {
    return request(`api/adm/tabelaprocedimentos/${id}`);
  }

  static async importar(data) {
    return request("api/adm/tabelaprocedimentos/import", {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  static async criar(data) {
    return request("api/adm/tabelaprocedimentos", {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  static async atualizar(id, data) {
    return request(`api/adm/tabelaprocedimentos/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  static async remover(id) {
    return request(`api/adm/tabelaprocedimentos/${id}`, { method: "DELETE" });
  }

  static async listarItens(tabelaId, { page = 1, limit = 20, q = "" } = {}) {
    const qs = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (q) qs.set("q", q);
    return request(`api/adm/tabelaprocedimentos/${tabelaId}/itens?${qs.toString()}`);
  }

  static async criarItem(tabelaId, data) {
    return request(`api/adm/tabelaprocedimentos/${tabelaId}/itens`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  static async atualizarItem(tabelaId, itemId, data) {
    return request(`api/adm/tabelaprocedimentos/${tabelaId}/itens/${itemId}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  static async removerItem(tabelaId, itemId) {
    return request(`api/adm/tabelaprocedimentos/${tabelaId}/itens/${itemId}`, {
      method: "DELETE",
    });
  }

  static async buscarItensCrossTabela({ clinicaId, tipo, q, limit = 8 }) {
    const qs = new URLSearchParams({ clinicaId, limit: String(limit) });
    if (tipo) qs.set("tipo", tipo);
    if (q) qs.set("q", q);
    return request(`api/adm/tabelaprocedimentos/itens/buscar?${qs.toString()}`);
  }
}

export { TabelaProcedimentoService };
